import z from 'zod'
import { BaseEntitySchema } from './Common'
import { zodErrorParser } from '@/utils/zod'

const SponsorshipStatus = [
  'ACTIVE',
  'CONCLUDED'
] as const

export const SponsorshipResponseSchema = BaseEntitySchema.extend({
  id: z.uuid(),
  subject: z.union([z.string(), z.object({ id: z.string() })]),
  name: z.string(),
  url: z.url(),
  beginningDate: z.string(),
  endDate: z.string().nullish(),
  status: z.enum(SponsorshipStatus)
}).strict()

export type SponsorshipResponse = z.infer<typeof SponsorshipResponseSchema>

export const zodSponsorshipResponseValidator = (
  data: SponsorshipResponse[]
) => zodErrorParser(
  'SponsorshipResponse',
  SponsorshipResponseSchema,
  data,
)
